import { render, staticRenderFns } from "./category-panel-nav-bar-tabs.vue?vue&type=template&id=3e51335a&"
import script from "./category-panel-nav-bar-tabs.vue.ts?vue&type=script&lang=ts&"
export * from "./category-panel-nav-bar-tabs.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports